import { Component, OnInit } from '@angular/core';
import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
import View from 'ol/View';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { fromLonLat } from 'ol/proj.js';
import { transform } from 'ol/proj.js';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import { Icon, Style } from 'ol/style';
import { MapService } from '../_services/map.service';
import { VehiclePosition } from '../_models/vehiclePosition';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import * as signalR from '@aspnet/signalr';
import { Subscription, timer, pipe, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-vehiclePosition',
  templateUrl: './vehiclePosition.component.html',
  styleUrls: ['./vehiclePosition.component.css']
})

export class VehiclePositionComponent implements OnInit {

  public data: VehiclePosition;
  vectorLayer;
  imei: string;
  map;
  vectorSource;
  position: VehiclePosition;
  private hubConnection: signalR.HubConnection;
  counter = 0;
  subscription: Subscription;
  currPosition: VehiclePosition;
  constructor(private route: ActivatedRoute, private mapService: MapService, private http: HttpClient) { }

  ngOnInit() {
    this.mapService.getLastPosition(this.route.snapshot.params['id']).subscribe(data => {
      this.position = data;
      this.imei = this.position.imei;
      this.initilizeMap();
    });

    if (environment.UseSqlDependency === true) {
      this.hubConnection = new signalR.HubConnectionBuilder()
        .withUrl('http://logimapsgpsapi.azurewebsites.net/maps')
        .build();

      this.hubConnection
        .start()
        .then(() => console.log('Connection started'))
        .catch(err => console.log('Error while starting connection: ' + err));
      this.hubConnection.on('transferpositiondata', (data) => {
        this.data = data;
        console.log(data);
        if (this.data.imei === this.imei) {
          this.position = this.data;
          const lonLat2 = [Number(this.position.latitude), Number(this.position.longitude)];
          this.setMarker(lonLat2);
          if (this.counter === 4) {
            this.centerMap(lonLat2);
            this.counter = 0;
          }
          this.counter++;
        }
      });
    } else {
      this.subscription = timer(10000, 15000).pipe(
        switchMap(() => this.getCurrPosition())
      ).subscribe();
    }


  }

  ngOnDestroy() {
    if (environment.UseSqlDependency === true) {
      this.hubConnection
        .stop()
        .then(() => console.log('Connection stopped'))
        .catch(err => console.log('Error: ' + err));
      this.hubConnection = null;
    } else {
      this.subscription.unsubscribe();
    }
  }

  getCurrPosition() {
    this.mapService.getLastPosition(this.route.snapshot.params['id']).subscribe(data => {
      this.currPosition = data;
      this.position = this.currPosition;
      const lonLat2 = [Number(this.position.latitude), Number(this.position.longitude)];
      this.setMarker(lonLat2);
      if (this.counter === 4) {
        this.centerMap(lonLat2);
        this.counter = 0;
      }
      this.counter++;
    });
    return this.mapService.getLastPosition(this.route.snapshot.params['id']);
  }
  initilizeMap() {
    const lonLat = [Number(this.position.latitude), Number(this.position.longitude)];
    this.map = new Map({
      layers: [
        new TileLayer({
          source: new OSM(),
        })
      ],
      target: 'map',
      view: new View({
        center: fromLonLat(lonLat),
        zoom: 16
      })
    });
    this.setMarker(lonLat);
  }

  setMarker(lonLat) {
    if (this.vectorLayer) {
      this.map.removeLayer(this.vectorLayer);
    }
    const iconFeatures = [];

    const iconFeature = new Feature({
      geometry: new Point(transform(lonLat, 'EPSG:4326',
        'EPSG:3857')),
    });

    iconFeatures.push(iconFeature);

    const vectorSource = new VectorSource({
      features: iconFeatures
    });

    const iconStyle = new Style({
      image: new Icon(/** @type {olx.style.IconOptions} */({
        anchor: [0.5, 46],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        opacity: 0.75,
        src: 'assets/marker.png'
      }))
    });


    this.vectorLayer = new VectorLayer({
      source: vectorSource,
      style: iconStyle
    });

    this.map.addLayer(this.vectorLayer);
  }

  centerMap(lonLat) {
    this.map.getView().setCenter(fromLonLat(lonLat));
    this.map.getView().setZoom(16);
  }
}
